import React, { useState } from "react";
import PopulateTrays from "./PopulateTrays";
import Button from "../Button";
import Input from "../Input";
import SingleTrayModal from "./SingleTrayModal";
import Trays from "./Trays";
import { fetchJson } from "../../lib/Fetching";

export default function TraysContainer({
  receiving_branch_id,
  laboratory_company_id,
  item_id,
}) {
  const [generation, setGeneration] = useState(0);
  const [route, setRoute] = useState({ view: "trays", item_id });
  const [traySearch, setTraySearch] = useState("");
  const [foundTray, setFoundTray] = useState(null);

  const reloadTrays = () => {
    setGeneration(generation + 1);
    setRoute({ view: "trays" });
  };

  const { view } = route;

  const loadTray = (itemId) =>
    fetchJson("/trays/trays.json", { item_id: itemId }).then((trays) => {
      if (trays.length == 1) {
        setFoundTray(trays[0]);
      } else {
        setFoundTray(null);
        alert("No tray found with that id.");
      }
    });

  const findTray = () => {
    if (!traySearch || traySearch.length == 0) return;
    loadTray(traySearch);
  };

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <Button
          title="Trays"
          highlight={view === "trays"}
          onClick={reloadTrays}
          icon="fa-refresh"
          style={{ marginRight: 20, textTransform: "uppercase" }}
        />
        <Button
          title="Receive and Schedule Samples"
          highlight={view === "populate"}
          onClick={() => setRoute({ view: "populate" })}
          style={{ marginRight: 20, textTransform: "uppercase" }}
        />
        <div className="input-group" style={{ width: 100, display: "inline-flex" }}>
          <Input
            value={traySearch}
            onChange={(e) => setTraySearch(e.target.value)}
            onPressEnter={findTray}
            placeholder={"Find Tray"}
            className="form-control input-sm"
          />
          <div className="input-group-btn">
            <Button title="Search" icon="fa-search" small onClick={findTray} />
          </div>
        </div>

        <a href="/trays/trays/rules" target="_blank" className="btn btn-default pull-right">
          <i className="fa fa-info-circle" />
          &nbsp; Rules
        </a>
      </div>
      {foundTray !== null && (
        <SingleTrayModal
          reloadTray={() => {
            loadTray("I" + foundTray.item_id);
            setGeneration(generation + 1);
          }}
          tray={foundTray}
          onClose={() => setFoundTray(null)}
        />
      )}
      {view === "populate" && (
        <PopulateTrays
          refreshTrays={() => {}}
          receivingBranchId={receiving_branch_id}
          laboratory_company_id={laboratory_company_id}
        />
      )}
      {view === "trays" && <Trays key={generation} itemId={route.item_id} />}
    </div>
  );
}
